"use client";
import {
  useMenuContext
} from "./YGMEBI3A.js";
import {
  useMenubarContext
} from "./KA4GX64Z.js";
import {
  useComboboxProviderContext
} from "./W76OTZCC.js";
import {
  useCompositeStoreProps
} from "./A6ER4BO6.js";
import {
  useHovercardStoreProps
} from "./A3PM2ZVJ.js";
import {
  useStore,
  useStoreProps
} from "./4OZYHFMH.js";
import {
  useUpdateEffect
} from "./6O5OEQGF.js";
import {
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/menu/menu-store.ts
import * as Core from "@ariakit/core/menu/menu-store";
function useMenuStoreProps(store, update, props) {
  useUpdateEffect(update, [props.combobox, props.parent, props.menubar]);
  store = useCompositeStoreProps(store, update, props);
  store = useHovercardStoreProps(store, update, props);
  useStoreProps(store, props, "values", "setValues");
  return Object.assign(store, {
    combobox: props.combobox,
    parent: props.parent,
    menubar: props.menubar
  });
}
function useMenuStore(props = {}) {
  const parent = useMenuContext();
  const menubar = useMenubarContext();
  const combobox = useComboboxProviderContext();
  props = __spreadProps(__spreadValues({}, props), {
    parent: props.parent !== void 0 ? props.parent : parent,
    menubar: props.menubar !== void 0 ? props.menubar : menubar,
    combobox: props.combobox !== void 0 ? props.combobox : combobox
  });
  const [store, update] = useStore(Core.createMenuStore, props);
  return useMenuStoreProps(store, update, props);
}

export {
  useMenuStoreProps,
  useMenuStore
};
